'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgLang(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("path", { d: "M9.31818 1.5H5.22727C4.55227 1.5 4.00614 2.04 4.00614 2.7L4 12.3C4 12.96 4.54614 13.5 5.22114 13.5H11.7727C12.4477 13.5 13 12.96 13 12.3V4.95176L9.31818 1.5ZM5.22727 12.2143V2.78571H8.88112L8.87254 5.6363H11.7727V12.2143H5.22727Z", fill: "currentColor" }),
        React__default.default.createElement("path", { d: "M3 4.5V12.5C3 13.6046 3.89543 14.5 5 14.5H12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })));
}

module.exports = SvgLang;
//# sourceMappingURL=Copy.js.map
